import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import vue from 'vue'
import config from '../../../config'

export async function getDeviceErrorData(condition={}){
    let response={}
    try {
        response = await axios.post(`${config.eastCoastDataApi()}BaseData/DeviceDisconnected/DeviceDisconnectedWithTimeRange`,condition)
  
    } catch (err) {
        console.error('iisi getDeviceErrorData: ', err)
        return response
    }
    
    Utils.setApiResponsSuccess(response)
    return response
}
export async function getDeviceErrorStatisticData(condition={}){
    let response={}
    try {
        response = await axios.post(`${config.eastCoastDataApi()}BaseData/DeviceDisconnected/DeviceDisconnectedCountWithTimeRange`,condition)
  
    } catch (err) {
        console.error('iisi getDeviceErrorStatisticData: ', err)
        return response
    }
    
    Utils.setApiResponsSuccess(response)
    return response
}